<template>
  <div
    class="modulartime"
    @click.prevent="focusField"
  >
    <div
      data-grid="nowrap"
      class="modulartime__wrapper grid--va-center"
    >
      <div
        data-grid="nowrap"
        class="modulartime__content grid--va-center grid--between cursor-pointer"
      >
        <ClockIcon class="modulartime__icon shrink-0" />

        <div
          data-grid="nowrap"
          class="modulartime__time grid--va-center"
          :class="{ 'grid--row-reverse': reversed }"
        >
          <input
            ref="inputNumber"
            min="0"
            type="number"
            v-bind="{ name }"
            placeholder="00"
            :value="_value"
            :max="limit"
            class="modulartime__valuefield text-center w-100 d-inline p-0"
            @blur="blurField"
            @input="userInput"
          >

          <div class="modulartime__colon">
            :
          </div>

          <div
            data-grid="center"
            class="modulartime__placeholder"
          >
            00
          </div>
        </div>

        <div
          data-grid="column"
          class="modulartime__controls shrink-0 h-100 grid--center"
        >
          <div
            data-grid
            class="modulartime__arrow modulartime__arrow--up grid--va-center"
            @click.prevent.stop="controlsChange(1)"
          >
            <ChevronTopIcon class="w-100" />
          </div>

          <div
            data-grid
            class="modulartime__arrow modulartime__arrow--down grid--va-center"
            @click.prevent.stop="controlsChange(-1)"
          >
            <ChevronTopIcon class="w-100" />
          </div>
        </div>
      </div>

      <label
        v-if="label"
        :for="name"
        class="modulartime__label"
      >
        {{ label }}
      </label>
    </div>
  </div>
</template>

<script>
import ClockIcon from '../icons/ClockIcon.vue'
import ChevronTopIcon from '../icons/ChevronTopIcon.vue'

export default {
  name: 'ModularTime',

  components: {
    ClockIcon,
    ChevronTopIcon
  },

  props: {
    name: {
      type: String,
      default: () => ''
    },

    label: {
      type: String,
      default: () => ''
    },

    modelValue: {
      type: Number,
      required: true
    },

    segment: {
      type: String,
      required: true,
      validator (segment) {
        return ['hours', 'minutes'].includes(segment)
      }
    },

    limit: {
      type: Number,
      default: () => Infinity
    }
  },

  emits: ['input', 'update:modelValue'],

  computed: {
    _value () {
      return String(this.modelValue).padStart(2, '0')
    },

    maxLength () {
      let decrease = 0

      const { _value } = this

      for (let i = 0, len = 2; i < len; i++) {
        if (_value[i] !== '0') break

        decrease++
      }

      return decrease + 2
    },

    reversed () {
      return this.segment === 'minutes'
    }
  },

  methods: {
    dispatchTime (time) {
      this.$emit('input', time)
      this.$emit('update:modelValue', time)
    },

    userInput (event) {
      const valueField = event.target.value
        .replace(/\D+/g, '')
        .replace(/^0+/g, '')
        .substring(0, 2)

      if (event.target.value.length > 2) {
        this.$refs.inputNumber.value = valueField
      }

      const clampedValue = Math.max(0, Math.min(+(valueField || 0), this.limit))

      this.dispatchTime(clampedValue ?? 0)
    },

    controlsChange (increment) {
      const { dispatchTime, modelValue, limit } = this

      dispatchTime(Math.max(0, Math.min(modelValue + increment, limit)))
    },

    focusField () {
      this.$refs.inputNumber.focus()
    }
  }
}
</script>

<style lang="scss" scoped>
  .modulartime {
    --borderColor: #00D2FF;

    & + .modulartime {
      margin-inline: 22px 0;
    }

    &__wrapper {
      gap: 10px;
    }

    &__content {
      width: 124px;
      height: 40px;
      border-radius: 24px;
      padding-inline: 16px;
      border: solid 1px var(--borderColor);
    }

    &__label {
      font: 400 1.4rem / 1.8rem "Nunito", sans-serif;
    }

    &__icon {
      width: 20px;
      height: 20px;
    }

    &__icon,
    &__arrow {
      color: #D3C8E2;
    }

    &__time {
      width: fit-content;
    }

    &__valuefield {
      border: 0 none;
      outline: 0 none;
      background-color: transparent;

      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        margin: 0;
        -webkit-appearance: none;
      }

      &[type=number] {
        -moz-appearance: textfield;
      }

      &:invalid {
        color: red !important;
      }
    }

    &__placeholder,
    &__valuefield {
      width: 20px;
    }

    &__colon,
    &__valuefield,
    &__placeholder {
      font: 400 1.4rem / 2rem "Nunito", sans-serif;
    }

    &__placeholder {
      color: rgb(var(--gray16));
    }

    &__controls {
      width: 12px;
    }

    &__arrow {
      height: 11px;

      &--down {
        transform: rotate(180deg);
      }
    }
  }
</style>
